import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { map } from 'rxjs';
import { LicenseDependentButtonModel } from '../../models/license-dependent-button.model';
import { PaymentType } from '../../models/payment-type.enum';
import { ActionType } from '../../models/action-type.enum';
import { TransportMode } from '../../models/transport-mode.enum';
import { ArticleItem } from '../../models/article-item.model';
import { LabelType } from '../../models/label-type.enum';

@Component({
  selector: 'hazmatsuite-next-article-selection-button',
  templateUrl: './article-selection-button.component.html',
  styleUrls: ['./article-selection-button.component.scss']
})
export class ArticleSelectionButtonComponent {
  @Input() transportMode: TransportMode = TransportMode.Unknown;

  @Output() beforeNavigationAction = new EventEmitter();
  @Output() selectArticle = new EventEmitter<ArticleItem>();

  labelTypes: typeof LabelType = LabelType;

  labelTypeTranslations$ = this.languageService.translations$.pipe(
    map(data => data['LabelTypeResource'])
  );

  public showArticleSelectionModal = false;

  public licenseBtnModel: LicenseDependentButtonModel = {
    IsHeroButton: false,
    ButtonAlignmentRight: false,
    OpenInNewTab: false,
    ContactText: '',
    IsPaymentDetailView: false,
    PaymentType: PaymentType.Undefined,
    ActionType: ActionType.Undefined,
    ButtonIcon: 'ifc-custom ifc-search',
    ShowCreditsModal: false,
    Toolname: '',
    FullWidth: false
  }

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['LabelTypeResource']);
  }
}
